import * as o from "react";
const t = /* @__PURE__ */ o.createContext(void 0);
process.env.NODE_ENV !== "production" && (t.displayName = "ButtonGroupButtonContext");
const n = t;
export {
  n as default
};
//# sourceMappingURL=ButtonGroupButtonContext.mjs.map
